export const GET_BUSINESESS_PROCESS = "GET_BUSINESSES_PROCESS";
export const GET_BUSINESSES_START = "GET_BUSINESSES_START";
export const GET_BUSINESSES_SUCCESS = "GET_BUSINESSES_SUCCESS";
export const GET_BUSINESSES_ERROR = "GET_BUSINESSES_ERROR";

export const SET_BUSINESS_FILTER_PROCESS = "SET_BUSINESS_FILTER_PROCESS";
export const SET_BUSINESS_FILTER_SUCCESS = "SET_BUSINESS_FILTER_SUCCESS";
export const SET_BUSINESS_FILTER_START = "SET_BUSINESS_FILTER_START";
export const SET_BUSINESS_FILTER_ERROR = "SET_BUSINESS_FILTER_ERROR";
